"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalize = void 0;
/**
 * Return a capitalized copy of a string
 * @public
 *
 * @param str - Text string to capitalize
 *
 * @returns Copy capitalized of the str
 *
 * @example
 * ```ts
 * cont result = capitalize('sOme-text_tO-capitalize')
 * console.log(result);
 * // -> 'Some Text To Capitalize'
 * ```
 */
function capitalize(str) {
    return str
        .toLowerCase()
        .replace(/[-_]/g, ' ')
        .replace(/\b\w/g, (l) => l.toUpperCase());
}
exports.capitalize = capitalize;
//# sourceMappingURL=capitalize.js.map